import { render, staticRenderFns } from "./ContratoGrillaDetalle.vue?vue&type=template&id=46f46e20&"
import script from "./ContratoGrillaDetalle.vue?vue&type=script&lang=ts&"
export * from "./ContratoGrillaDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./ContratoGrillaDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46f46e20', component.options)
    } else {
      api.reload('46f46e20', component.options)
    }
    module.hot.accept("./ContratoGrillaDetalle.vue?vue&type=template&id=46f46e20&", function () {
      api.rerender('46f46e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Contratos/ContratoGrillaDetalle.vue"
export default component.exports